var QuestionController = require('./question_controller');
var ajaxCalls = require('./ajaxCalls');

var list = function(exam,global) {

    var modalDiv = $('#'+ global.modal);
    $(modalDiv).on('hidden.bs.modal', function (e) {
        $(modalDiv).find('.modal-content').html('');
    });
    var i = 0;
    var modalcontentstr = '<div class="modal-header">Questions</div><div class="modal-body">' +
        'Use the table of buttons below to jump to any question in the exam. The color of the button indicates whether that particular question has been answered, marked guessed, skipped, or is still unseen.' +
        '<ul class="questions-list">';
    _(global.response.answers).each(function(answer) {
        var class_name='';
        if (answer.guessed == 'yes') {
            class_name = 'guessed';
        } else if (answer.status == 'skipped') {
            class_name='skipped';
        } else if (typeof answer.answer !== 'undefined' && answer.answer) {
            class_name = 'answered';
        }
        modalcontentstr += '<li id="'+ i++ +'" class="'+ class_name +'">' + i + '</li>';
    })
    modalcontentstr += '</ul><ul class="key">' +
        '<li class="answered">Answered</li>' +
        '<li class="guessed">Guessed</li>' +
        '<li class="skipped">Skipped</li>' +
        '<li>Unseen</li>' +
        '</ul>' +
        '</div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div>';
    var modalContent = $.parseHTML(modalcontentstr);
    $(modalContent).find('li').each(function() {
        $(this).click(function() {
            // update the answer
            var answer = global.response.answers[global.questionIndex];
            ajaxCalls.quizUpdateAnswer(global.userId,global.quizId,answer);

            global.questionIndex = parseInt(this.id);
            QuestionController.setQuestion(exam,global,global.imageHost);
            $(modalDiv).modal('hide');
        });
    })
    $(modalDiv).find('.modal-content').append(modalContent);
    $(modalDiv).modal();

}

module.exports = list;


//////////////////
// WEBPACK FOOTER
// ./src/quiz_list.js
// module id = 325
// module chunks = 0